import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=c2504972&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2504972')) {
      api.createRecord('c2504972', component.options)
    } else {
      api.reload('c2504972', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=c2504972&", function () {
      api.rerender('c2504972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/components/ImportIn/ErrorMessage.vue"
export default component.exports